import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER} from "redux-persist";

// import storageSession from "redux-persist/lib/storage/session";
import storage from "redux-persist/lib/storage"; // localStorage
import businessReducer from "store/reducers/businessSlice";
import subscriptionReducer from "store/reducers/subscriptionSlice";
import notificationReducer from "store/reducers/notificationSlice";

const rootReducer = combineReducers({
    business: businessReducer,
    subscription: subscriptionReducer,
    notification: notificationReducer,
});

const persistConfig = {
    key: "root",
    // storage: storageSession,
    storage,
    whitelist: ["business", "subscription"], // Persist both business and subscription data
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);

export default store;
